export default {
  Table_Common: {
    TuoDong: 'Drag',
    ZhuanJieMa_MingCheng: 'Name',
    ZhuanJie_Ma: 'Code',
    TingYon_ZhuanTai: 'Inactive Status',
    ChuangJian_ShiJian: 'Create time',
    JiaZai_Zhong: 'Loading',
    ShouJi_HaoMa: 'Phone',
    DianHua: 'Phone',
    XingBie: 'Sex',
    ZhiGong_LeiBie: 'Category',
    ZhenJin: 'Fee',
    Yuan: '',
    JueSe: 'Role',
    YuanGong_ZhuangTai: 'Status',
    QiYong: 'Enable',
    TingYong: 'Unable',
    ShiFou_CanYu_PaiBan: 'Scheduling',
    ShiFou_PaiBan: 'Scheduling',
    Shi: 'Yes',
    Fou: 'No',
    PaiBan: "Scheduling's",
    YouXiang: 'Email',
    ChuSheng_RiQi: 'DOB',
    CaoZuo: 'Operation',
    Nan: 'Male',
    Nv: 'Female',
    MiaoShu: 'Description',
    CaiDan_MingCheng: 'Menu name',
    LuYou: 'Router',
    GongNeng_QuanXian: 'Authority',
    YaoFei: 'Prescription',
    ZhenJiu_JinE: 'Acupuncture',
    TaoPiao: 'Ticket',
    YouFei: 'Postage',
    ZhenJin_JinE: 'Fee',
    TuiNa_ZhengGu: 'Massage/Boning',
    BaGuan_JinE: 'Cupping',
    YouHuiQuan_MingCheng: 'Coupon name',
    QiYong_ZhuangTai: 'Enable?',
    MianE: 'Denomination',
    ManJian_MuBiao_JinE: 'Full deduction',
    ShiYong_QingKuang: 'Usage situation',
    Yi_ShiYong: 'Used',
    Yi_FaFang: 'Issued',
    ShiYong_DanJu: 'Scope of use',
    GuoQi_ShiJian: 'Expiration time',
    GuoQi_RiQi: 'Expiration date',
    LaiYuan: 'Source',
    YiShi_Duan: 'Medic',
    GuanLi_Duan: 'Management',
    JianDang_ShiJian: 'Create time',
    ShouHuo_Ren: 'Consignee',
    YiDong_SheZhi: 'Mobile settings',
    MoRen_DiZhi: 'Default',
    SheWei_MoRen: 'Set as default',
    YaoPin_MingCheng_En: 'Name(En)',
    BianMa: 'Code',
    GuiGe_En: 'Sku(En)',
    NongSuo: 'Ratio',
    JingZhong: 'Weight',
    DanWei_ChengBen_Jia: 'Unit cost price',
    DanWei_ShouJia: 'Unit selling price',
    KuCun: 'Inventory',
    ChuFang_DanWei: 'Prescription unit',
    YaoPin_ZhuangTai: 'Enable',
    ChengFen_Yao: 'Component drug',
    DingDan_ZhuangTai: 'Order status',
    DingDan_JinE: 'Order amount',
    XiaDan_Ren: 'Create staff name',
    ShenPi_Ren: 'Examine staff name',
    GengXin_ShiJian: 'Update time',
    ShenPi_ShiJian: 'Examine time',
    ChengBen_Jia: 'Cost price',
    XiaDan_ShuLiang: 'Order quantity',
    QianShou_ShuLiang: 'Receive quantity',
    Yi_QianShou: 'Signed',
    BenCi_QianShou: 'This signing',
    QianShou_ShiJian: 'Signing time',
    ShenPi_Zhong: 'Examine',
    Dai_QianShou: 'Ordered',
    Yi_WanCheng: 'Complete',
    BoHui: 'Reject',
    Yi_ZuoFei: 'Cancel',
    DiaoZheng_RenYuan: 'Create staff name',
    ShenHe_RenYuan: 'Examine staff name',
    DiaoZheng_Qian_KuCun: 'Inventory before',
    DiaoZheng: 'Difference',
    DiaoZheng_Hou_KuCun: 'Inventory new',
    XiangMu_MingCheng: 'Name',
    ZhongLei: 'Types',
    JiFei: 'Method',
    HanLiang: 'Content',
    ChongZhi_JinE: 'Recharge',
    ZengSong_JinE: 'Gift',
    ShiFou_ShouChong: 'Is First',
    YuE: 'Balance',
    GuiGe: 'Sku',
    JingMai: 'Meridian',
    XueWei: 'Acupoint',
    FangFa: 'Method',
    WeiZhi: 'Position',
    DanWei: 'Unit',
    XiangMu: 'Project',
    ZiTou: 'Prefix',
    RiQi_GeShi: 'Date Format',
    BuLing: 'Digit',
    QiShi: 'Number',
    LeiXing: 'Type',
    ShuLiang: 'Quantity',
    KeHu_BianHao: 'Customer No.',
    JiuZhen: 'Appointment',
    HeJi: 'Sum',
    XueWei_GeShu: 'Acupoint',
    DanJu_LeiXing: 'Record type',
    ShiYong_CiShu: 'Number of uses',
    YouHui_JinE_XianZhi: 'Limit discount',
    ZhongYi_ChuFang: 'CM prescription',
    ZhongYi_ChuFang_Zhen: 'CM prescription(Acup)',
    ZhongYi_ChuFang_Tui: 'CM prescription(Mas)',
    ZhongYi_ChuFang_Ba: 'CM prescription(Cup)',
    BingLi_BaoGao: 'Diagnosis Record',
    BingJia_ZhengMingShu: 'Sick Leave Certificate',
    DaoZhen_ZhengMingShu: 'Attendance Record',
    HuaiYun_ZhengMingShu: 'Pregnancy Certificate',
    ShouJu: 'Receipt',
    DaYin_ShiJian: 'Time',
    DaYin_Ren: 'Name',
    GuanLiYuan: 'Administrator',
    Biaozhun: 'Standard',
    GuiGe_BianMa: 'Sku Code',
    PinYin: 'Pin Yin',
    YaoPing_GuiGe: 'Specification',
    NongDu: 'Ratio',
    ShiFou_NongSuo: 'Is Ratio',
    TiaoMa: 'Barcode',
    PiCiHao: 'Batch',
  },
}
